import type { AbstractMesh, AnimationGroup, Scene } from "@babylonjs/core";

export default class PlayFloatingAnimation {
	public _scene: Scene;
	public _animationGroup: AnimationGroup | null = null;
	public _attachedMesh: AbstractMesh | null = null;

	// constructor(scene: Scene) {
	//     this._scene = scene;
	// }

	public onInitialize(): void {
		console.log("イニシャライズ");
		// アニメーショングループを取得
		this._animationGroup = this._scene.getAnimationGroupByName("fy-floating"); // 例: "Idle"
		if (!this._animationGroup) {
			console.error("指定されたアニメーショングループが見つかりません。");
		}

		// このクラスがアタッチされているオブジェクト（メッシュ）を取得
		this._attachedMesh = this._scene.getMeshByName("アタッチされたメッシュ名");
		if (!this._attachedMesh) {
			console.error("指定されたメッシュが見つかりません。");
		}

		// タップイベントを登録
		this._scene.onPointerObservable.add((pointerInfo) => {
			if (
				pointerInfo.pickInfo?.hit &&
				pointerInfo.pickInfo.pickedMesh === this._attachedMesh
			) {
				this.rotateObject(); // 回転処理を実行
			}
		});
	}

	public onStart(): void {
		// アニメーションを再生
		console.log("アニメーションを再生");
		if (this._animationGroup) {
			this._animationGroup.start(true); // trueでループ再生
		}
	}

	public onStop(): void {
		// アニメーションを停止
		if (this._animationGroup) {
			this._animationGroup.stop();
		}
	}

	public rotateObject(): void {
		if (this._attachedMesh) {
			// 例: Y軸を中心に45度回転させる
			this._attachedMesh.rotation.y += Math.PI / 4; // ラジアンで指定
		}
	}
}
